import { render, staticRenderFns } from "./RcvScL_Search.vue?vue&type=template&id=64ade2a2"
import script from "./RcvScL_Search.vue?vue&type=script&lang=js"
export * from "./RcvScL_Search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports